import { Spinner } from '@ebh/capsule';
import styles from './styles';

const LoadingScreen = () => {
  return (
    <div css={styles.container} data-testid="C5dE8fG1hI4jK7lM0nO-">
      <Spinner
        css={styles.spinner}
        size="4em"
        stroke={2}
        data-testid="P3qR6sT9uV2wX5yZ8aB-"
      />
    </div>
  );
};

export default LoadingScreen;
